export default __webpack_public_path__ + "static/media/Sonnant_4_3.86712b30.png";